import { Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'disagreementManagement',
    loadComponent: () => import('./disagreement-management/disagreement-management.component'),
  },
];

export default routes;
